import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterAutoexclusionUsers from 'views/partner/reports/autoexclusionUsers/filterAutoexclusionUsers'; // Importing filter component
import TableAutoexclusionUsers from 'views/partner/reports/autoexclusionUsers/tableAutoexclusionUsers'; // Importing table component
import DetailsAutoexclusionUsers from 'views/partner/reports/autoexclusionUsers/detailsAutoexclusionUsers'; // Importing details component
import RecordAutoexclusionUsers from 'views/partner/reports/autoexclusionUsers/recordAutoexclusionUsers'; // Importing record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the autoexclusion users view.
 * @extends JetView
 */
export default class autoexclusionUsersView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const right = {
            // Right section configuration
            type: 'wide',
            rows: [PlayersView, DetailsAutoexclusionUsers],
        };
        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                            $$('datatable').scrollTo(100, 0); // Scroll to top
                        },
                    },
                },
                {
                    view: 'pager', // Pager configuration
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('datatable');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Autoexcluidos'),
                                    ignore: {
                                        detailTittle: true,
                                        Action: true,
                                    },
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Autoexcluidos'),
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            Action: true,
                                        },
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            // Left section configuration
            css: 'int-left',
            rows: [
                FilterAutoexclusionUsers, // Filter component
                { id: 'res2', view: 'resizer' }, // Resizer
                TableAutoexclusionUsers, // Table component
                toolbar, // Toolbar
            ],
        };
        const avanc = {
            // Advanced details accordion
            view: 'accordion',
            multi: true,
            collapsed: true,
            cols: [{ header: _('Detalles Avanzados'), body: right }],
        };
        const avancResp = {
            // Responsive advanced details accordion
            view: 'accordion',
            multi: true,
            collapsed: true,
            rows: [
                {
                    id: 'dColl',
                    header: _('Detalles Avanzados'),
                    body: right,
                    minWidth: 150,
                    on: {
                        onItemClick: function () {
                            // Event handler for item click
                            var height;
                            $(function () {
                                height =
                                    $('.scrolling > .webix_scroll_cont').height() -
                                    $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                if (!$$('dColl').config.collapsed) {
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                } else {
                                    height =
                                        $('.scrolling > .webix_scroll_cont').height() -
                                        $('.webix_view.webix_form.scrolling.webix_layout_clean').height();
                                    $('.scrolling > .webix_scroll_cont').css({
                                        transform: 'translate3d(0px, -' + height + 'px, 0px)',
                                    });
                                }
                            });
                        },
                    },
                },
            ],
        };
        webix.ui.fullScreen(); // Set the UI to full screen
        return {
            // Return the main layout configuration
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            css: 'scrolling',
            rows: [
                {
                    height: 'auto',
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left section
                        { id: 'res', view: 'resizer' }, // Resizer
                        document.body.offsetWidth < 500 ? avancResp : avanc, // Responsive accordion
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check for mobile screen size
                $$('res').hide(); // Hide resizer
                $$('res2').hide(); // Hide second resizer
                var childs = $$('toolbar').getChildViews(); // Get child views of toolbar
                $$('toolbar').removeView(childs[2]); // Remove export dropdown from toolbar
                $$('pagerA').define('group', 1); // Define pager group
            }
        });
    }
}

// FILE DOCUMENTED
